module.exports = __webpack_public_path__ + "static/media/first.a980d52e.svg";